import { useEffect } from 'react';
import { clx } from '../../lib/utils';
import { XIcon } from '../icons/XIcon';

interface IModalProps {
  children: React.ReactNode;
  containerClassName?: string;
  hideCloseButton?: boolean;
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
}

export const Modal = ({
  children,
  containerClassName,
  hideCloseButton = false,
  isOpen,
  onClose,
  title,
}: IModalProps) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (!onClose) return;

      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  return (
    <div
      className={clx(
        'safe-area-padding fixed inset-0 flex flex-col items-center justify-center',
        isOpen ? 'flex' : 'hidden'
      )}
    >
      {/* Blur the background */}
      <div className="fixed inset-0 backdrop-blur-sm" onClick={onClose} />

      <div
        className={clx(
          'bg-background-modal rounded-4xl relative flex flex-col border px-4 py-3 text-center',
          containerClassName || ''
        )}
      >
        {/* Title */}
        {title && <h2 className="text-xl font-medium">{title}</h2>}

        {/* Close button */}
        {onClose && !hideCloseButton && (
          <button
            onClick={onClose}
            type="button"
            className="text-primary bg-background-tertiary absolute right-4 top-3 flex size-6 items-center justify-center rounded-full border"
          >
            <XIcon />
          </button>
        )}

        {/* Content */}
        {children}
      </div>
    </div>
  );
};
